import {SET_SYSTEM_DATE} from '../constants/actionTypes';

export const setDate = (newDate) => {
  return dispatch => {
      dispatch ({type:SET_SYSTEM_DATE,newDate});
  };
};
